

exports.__esModule = true;
var $meta = exports.$meta = window.meta || {};
var $cookies = exports.$cookies = window.cookies || {};
var $config = exports.$config = window.config || {};
angular.value("$meta", $meta);
angular.value("$cookies", $cookies);
angular.value("$config", $config);


//////////////////
// WEBPACK FOOTER
// ./components/squid/dist/core/config.js
// module id = ./components/squid/dist/core/config.js
// module chunks = 1